import { VxeUI } from 'vxe-pc-ui';

VxeUI.setConfig({
    // 权限码控制
    permissionMethod ({ code }) {
        console.log('check permission code:', code);
        if (code === 'userManager') {
            return {
                visible: true,
                disabled: true,
            };
        }
        return {
            visible: true,
            disabled: false,
        };
    },
});
